var _path, _path2, _path3, _path4, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Statistics50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "M23 5H25V41H23z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "M20.5 31.4H22.5V45.599999999999994H20.5z",
    transform: "rotate(45.001 21.495 38.505)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "M25.5 31.4H27.5V45.599999999999994H25.5z",
    transform: "rotate(134.999 26.51 38.51)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFD8DC",
    d: "M4 8H44V36H4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#607D8B",
    d: "M3 7H45V11H3zM3 35H45V37H3zM31.5 42A1.5 1.5 0 1 0 31.5 45 1.5 1.5 0 1 0 31.5 42zM16.5 42A1.5 1.5 0 1 0 16.5 45 1.5 1.5 0 1 0 16.5 42z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C51162",
    d: "M31.9 18.9L26 24.9 20 18.9 11.9 26.9 14.1 29.1 20 23.1 26 29.1 34.1 21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C51162",
    d: "M36 24L29 17 36 17z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Statistics50);
export default __webpack_public_path__ + "static/media/icons8-statistics-50.87d61d2cd3d6aab5f67efa51aafeedb5.svg";
export { ForwardRef as ReactComponent };